/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzExMSI+PHBhdGggZD0ibS42MyAxLjg2aDE0Ljc1djFoLTE0Ljc1eiIvPjxwYXRoIGQ9Im0zLjk3IDcuNWg4LjA1djFoLTguMDV6Ii8+PHBhdGggZD0ibTYuMDkgMTMuMTRoMy44MnYxaC0zLjgyeiIvPjwvZz48L3N2Zz4=";